module.exports = __webpack_public_path__ + "img/ShotaArveladze-TemurKetsbaia.9c64debe.webp";